if (typeof DynaCore_GridConfig == 'undefined') {
    $(document).ready(function () {
        DynaCore_GridConfig.init();
    });

    var DynaCore_GridConfig =
    {
        /**
         * Inicializace jednotlivych objektu
         */
        init: function () {
            DynaCore_GridConfig.fieldsInit();
        },

        /**
         * Prida pole
         *
         * @param element
         */
        fieldAdd: function (element) {
            var fieldIndex = $('#fields').children('.btn').length;
            var fieldId = $(element).data('field-id');

            $.ajax({
                type: 'get',
                url: '/core/grid-config/field-add/',
                data: {_ch: $('#_ch').val(), fiId: fieldId, fiIn: fieldIndex},
                dataType: "json",
                success: function () {
                    var html = '<div class="btn btn-sm btn-block btn-outline-dark" data-field="' + fieldIndex + '" data-field-id="' + fieldId + '">' + $(element).text() + '</div>';

                    $('#fields').append(html);

                    if ($('#fields-list > .btn').length == 0) {
                        $('#fields-list-empty').removeClass('d-none');
                        $('#fields-list').addClass('d-none');
                    }

                    DynaCore_GridConfig.fieldsInit();
                }
            });
        },

        /**
         * Upraveni objektu typu Text
         *
         * @param element
         */
        fieldEdit: function (element) {
            var fieldIndex = $(element).data('field');
            var url = '/core/grid-config/field-edit/?_ch=' + $('#_ch').val() + '&fieInd=' + fieldIndex;

            $(document).load(url, function (form) {
                Lemo_Modal
                    .setId('modal-container-gridconfig-field-edit')
                    .setTitle('Edit field')
                    .setContent(form)
                    .setSize('large')
                    .addButton('change', '<i class="fas fa-fw fa-check"></i> ' + translate('Change'), 'btn btn-primary', function () {
                        $.ajax({
                            type: 'post',
                            url: url,
                            data: $('#gridConfigField').find(':input').serialize(),
                            dataType: "json",
                            success: function () {
                                Lemo_Modal.close();
                            },
                            error: function (html) {
                                Lemo_Alert.addDanger('Some form fields are not filled up or not filled correctly');

                                $('#dialogBody').html(html.responseText);
                            }
                        });
                    })
                    .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                        Lemo_Modal.close();
                    });

                Lemo_Modal.build();

                DynaBase_Overlay.hide();
            });
        },

        /**
         * Smaze pole
         *
         * @param element
         */
        fieldDelete: function (element) {
            var fieldId = $(element).data('field-id');
            var fieldIndex = $(element).data('field');

            Lemo_Modal
                .setId('modal-container-gridconfig-field-delete')
                .setTitle('Remove field')
                .setContent('<p class="text">' + translate('Do you really want to remove selected field?') + '</p>')
                .addButton('remove', '<i class="fas fa-fw fa-trash"></i> ' + translate('Remove'), 'btn btn-danger', function () {
                    $.ajax({
                        type: 'get',
                        url: '/core/grid-config/field-delete/',
                        data: {_ch: $('#_ch').val(), fiIn: fieldIndex},
                        dataType: "json",
                        success: function () {
                            $(element).remove();

                            var html = '<div class="btn btn-sm btn-block btn-outline-dark" data-field-id="' + fieldId + '">' + $(element).text() + '</div>';

                            $('#fields-list').append(html).removeClass('d-none');
                            $('#fields-list-empty').addClass('d-none');

                            DynaCore_GridConfig.fieldsInit();
                        },
                        complete: function () {
                            Lemo_Modal.close();
                        }
                    });
                })
                .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                    Lemo_Modal.close();
                });

            Lemo_Modal.build();
        },

        /**
         * Inicializace poli
         */
        fieldsInit: function () {
            DynaCore_GridConfig.fieldsInitContextMenu();
            DynaCore_GridConfig.fieldsInitDragDrop();
            DynaCore_GridConfig.fieldsInitSortable();
        },

        /**
         * Inicializace kontextoveho menu
         *
         * @param e
         * @param element
         */
        fieldsInitContextMenu: function (e, element) {
            $('#fields').off('contextmenu', '.btn');
            $('#fields').on('contextmenu', '.btn', function (e) {
                var element = this;

                DynaBase_ContextMenu.addHeader(translate('Field'));

                // Tlacitko - Upravit
                DynaBase_ContextMenu.addButton(translate('Edit'), 'pencil', function () {
                    DynaCore_GridConfig.fieldEdit(element);
                });

                DynaBase_ContextMenu.addDivider();

                // Tlacitko - Odstranit
                DynaBase_ContextMenu.addButton(translate('Remove'), 'trash', function () {
                    DynaCore_GridConfig.fieldDelete(element);
                });

                // Sestaveni
                DynaBase_ContextMenu.build(e, element);

                return false;
            });
        },

        /**
         * Inicializace presouvani poli
         */
        fieldsInitDragDrop: function () {
            $('#fields-list > .btn').draggable({
                revert: 'invalid',
                addClasses: false
            });

            $('#fields').droppable({
                accept: '#fields-list > .btn',
                addClasses: false,
                greedy: false,
                hoverClass: 'over',
                drop: function (event, ui) {
                    $(ui.draggable).remove();

                    DynaCore_GridConfig.fieldAdd(ui.draggable);
                }
            });
        },

        /**
         * Inicializace razeni poli
         */
        fieldsInitSortable: function () {
            var indexFieldOld = null;
            var indexFieldNew = null;

            $('#fields').sortable({
                axis: 'y',
                items: '.btn',
                forceHelperSize: true,
                forcePlaceholderSize: true,
                start: function (e, ui) {
                    indexFieldOld = $(ui.item).index();
                },
                update: function (e, ui) {
                    indexFieldNew = $(ui.item).index();

                    $.ajax({
                        type: 'get',
                        url: '/core/grid-config/field-sort/',
                        data: {_ch: $('#_ch').val(), o: indexFieldOld, n: indexFieldNew},
                        dataType: "json",
                        success: function () {
                            DynaCore_GridConfig.fieldsReindex();
                        }
                    });
                }
            });
        },

        fieldsReindex: function () {
            $('#fields').children('.btn').each(function (index, field) {
                $(field).attr('data-field', index);
            });
        }
    }
}
